import React, { Component } from "react";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import i18n from "../../../../i18n";
import { Button, Tab, Table, Tabs } from "react-bootstrap";
import PriceComparisonSellingContainer from "../../../../containers/modules/report/price-comparison/selling";
import PriceComparisonPurchasingContainer from "../../../../containers/modules/report/price-comparison/purchasing";

const MySwal = withReactContent(Swal);
export class PriceComparisonReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbs: [
        { link: process.env.APP_URL, title: i18n.t("Home"), class: " text-gray-600" },
        { link: null, title: i18n.t("Report"), class: " text-gray-600" },
        { link: null, title: i18n.t("Price Comparison"), class: " text-gray-500" },
      ],
    }
  }

  render() {
    return (
      <div id="customer-type">
        <Breadcrumbs url={this.state.breadcrumbs} tools={false} />
        <div
          id="kt_content_container"
          className="d-flex flex-column-fluid align-items-start container-fluid"
        >

          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-body pt-3">
                <Tabs
                  defaultActiveKey="selling"
                  id={"tabs"}
                  className="mb-3"
                >
                  <Tab eventKey="purchasing" title={i18n.t("Price Comparison Purchasing")}>
                    <PriceComparisonPurchasingContainer

                    />
                  </Tab>
                  <Tab eventKey="selling" title={i18n.t("Price Comparison Selling")}>
                    <PriceComparisonSellingContainer

                      {...this.props}
                    />
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

export default PriceComparisonReport;
